import { useRequirementDefinitionsSettings } from "./useRequirementDefinitionsSettings";

type MultiParams = Parameters<typeof useRequirementDefinitionsSettings>[0];

type Params = Omit<MultiParams, "requirementDefinitions"> & {
  requirementDefinition: MultiParams["requirementDefinitions"][0];
};

export const useRequirementDefinitionsSetting = (params: Params) => {
  const requirementDefinitionsSettings = useRequirementDefinitionsSettings({
    ...params,
    requirementDefinitions: [params.requirementDefinition]
  });

  const data = params.requirementDefinition.dataSourceId
    ? requirementDefinitionsSettings.data?.[
        params.requirementDefinition.dataSourceId
      ]
    : undefined;

  return {
    ...requirementDefinitionsSettings,
    data
  };
};
